export default __webpack_public_path__ + "static/media/main stone.3fbe6638.png";